import { IFilter } from '@root/modules/Sellers/Product/interfaces';
import { formatDateTime } from '@root/utils/helpers/formatDate';
import { Col, Row, Table, Typography } from 'antd';
import { useEffect, useState } from 'react';
import ProductService from '../services/product';

const Columns = [
  {
    title: 'No',
    dataIndex: 'no',
    key: 'no',
    width: 121
  },
  {
    title: 'Quantity',
    dataIndex: 'estimateQuantity',
    key: 'estimateQuantity',
    width: 209
  },
  {
    title: '입고완료일',
    dataIndex: 'created_at',
    key: 'created_at'
  }
];
const ReceivingDetails = ({ productId }: { productId: number }) => {
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [rows, setRows] = useState();
  const [totalRows, setTotalRows] = useState(0);

  const getList = async () => {
    setLoading(true);

    const result = await ProductService.getReceivingDetails(productId, {
      page,
      limit: 10
    });

    const data = result.data?.map((item: any) => {
      return {
        ...item,
        key: item.id,
        no: item.id,
        created_at: formatDateTime(item.quotation.importInfo.created_at)
      };
    });

    setRows(data);
    setTotalRows(result?.meta?.totalItems ?? 0);
    setLoading(false);
  };

  useEffect(() => {
    getList();
  }, []);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data.type === 'REFRESH_INTERGRATION_HISTORY') {
        getList();
      }
    };

    window.addEventListener('message', handleMessage);
    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  useEffect(() => {
    getList();
  }, [page]);

  return (
    <div
      style={{
        borderRadius: 'var(--global-corner-md, 6px)',
        background: '#FFF',
        boxShadow: '0px 0px 32px 0px rgba(136, 152, 170, 0.15)'
      }}
    >
      <div className="busk-sellerSubHead">
        <Row align="middle">
          <Col flex="auto">
            <Typography.Text>입고내역</Typography.Text>
          </Col>
        </Row>
      </div>
      <Table
        className="busk-table table-align-left"
        pagination={{
          pageSize: 10,
          total: totalRows,
          onChange: (newPage) => {
            setPage(newPage);
          }
        }}
        loading={loading}
        columns={Columns}
        dataSource={rows}
      />
    </div>
  );
};

export default ReceivingDetails;
